<template>
  <div>
    <section class="latest-events content">
      <div class="container">
        <div class="main-heading text-center">
          <h1> {{title ||"Upcoming events" }}</h1>
        </div>
        <div style="width: 100%" v-if="eventData.length === 0">
          <p class="text-center no-data" v-if="eventData.length === 0">No Data Available !</p>
          <!-- <p class="text-center no-data" v-if="participatingEvents.length > 0">Currently, this {{type}} is not hosting any Upcoming Events, Click <span @click="handleViewAll" class="link-btn">here </span> to see their Team events or Game Schedule.</p> -->
        </div>
        <div class="events-wrap" v-else>
          <div
            class="event-detail"
            v-for="(event, index) in eventData"
            :key="index"
          >
            <component :is="component" :event="event" :view-only="true" />
          </div>
        </div>
        <div
          class="col-md-12 text-center view-all"
          v-if="!_.isEmpty(eventData)"
        >
          <button
            type="button"
            class="btn btn-default text-center"
            @click="handleViewAll"
          >
            View All
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import AthleteCard from "../../components/Atheletes/AthleteEvents/EventCard";
import CollegeCard from "@/components/College/CollegeEvents/EventCard";
import ClubCard from "@/components/Club/ClubEvents/EventCard";

const TYPE_TO_COMPONENT_MAPPER = {
  athlete: AthleteCard,
  club: ClubCard,
  college: CollegeCard
};

export default {
  name: "event",
  components: {
    AthleteCard,
    ClubCard,
    CollegeCard
  },
  props: {
    title:{
      type:String,
      required:false
    },
    eventData: {
      type: Array
    },
    participatingEvents:{
      type:Array,
      default:[]
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    component() {
      return TYPE_TO_COMPONENT_MAPPER[this.type];
    }
  },
  methods: {
    convertDate(d) {
      return moment(d).format("MMMM,Do");
    },
    handleViewAll() {
      this.$emit("view-all");
    }
  }
};
</script>

<style lang="scss" scoped>
.events-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .event-detail {
    width: 25%;
    padding: 0 15px;
    max-width: 400px;
    margin-bottom: 30px;
  }
}
.no-data {
  font-size: 14px;
  color: #000;
  margin-bottom: 40px !important;
}

@media only screen and (max-width: 1200px) {
  .events-wrap {
    .event-detail {
      width: 33.33%;
    }
  }
}

@media only screen and (max-width: 991px) {
  .events-wrap {
    .event-detail {
      width: 50%;
    }
  }
}

@media only screen and (max-width: 575px) {
  .events-wrap {
    .event-detail {
      width: 100%;
    }
  }
}

.link-btn{
  color: blue;
  cursor: pointer;
  font-weight: bolder;
  text-decoration: underline;
  &:hover{
    color: rgb(28, 28, 112);
  }
}

</style>
